import styled from 'styled-components';
import { COLOR_WHITE, COLOR_RED, COLOR_BLACK } from '../../../../assets/styles/colors';
import { BP_TABLET_MAX } from '../../../../assets/styles/breakpoints';

export default styled.tr`
  background: ${COLOR_WHITE};
  &:first-child {
    td {
      &:first-child {
        border-top-left-radius: 0px;
      }
      &:last-child {
        border-top-right-radius: 0px;
      }
    }
  }
  &:last-child {
    td {
      &:after {
        display: none;
      }
      &:first-child {
        border-bottom-left-radius: 12px;
      }
      &:last-child {
        border-bottom-right-radius: 12px;
      }
    }
  }
  td {
    padding: 18px 0px;
    text-align: center;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      height: 1px;
      width: 100%;
      background: rgba(47, 46, 65, 0.1);
      left: 0;
    }
    &:first-child {
      text-align: left;
      padding-left: 32px;
      width: 194px;
      div {
        display: flex;
      }
      &:after {
        width: calc(100% - 32px);
        right: 0px;
        left: auto;
      }
    }
    &:last-child {
      padding-right: 32px;
      text-align: center;
      width: 185px;
      &:after {
        width: calc(100% - 32px);
        right: auto;
        left: 0px;
      }
    }
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    display: flex;
    margin-bottom: 16px;
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    border-radius: 12px;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    td {
      padding: 0px 0px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
      &:after {
        display: none;
      }

      &:first-child {
        padding-bottom: 24px;
        padding-top: 24px;
        padding-left: 16px;
        padding-right: 16px;
        width: 50%;
      }
      &:last-child {
        align-items: flex-end;
        padding-top: 24px;
        padding-bottom: 24px;
        padding-left: 16px;
        padding-right: 16px;
        width: 50%;
      }
    }
  }
`;

export const AlertSC = styled.span`
  position: relative;
  width: 16px;
  height: 16px;
  background: ${COLOR_RED};
  color: ${COLOR_WHITE};
  margin-top: 5px;
  margin-left: 8px;
  font-size: 12px;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  &:before {
    content: '!';
    color: white;
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
  }
  &.black {
    background: ${COLOR_BLACK};
  }
`;
